<template>
  <header
    :class="{
      onlineNotReady: !isOnlineReady,
      onlineReadyNotRunning: isOnlineReady && !isOnlineRunning,
      onlineRunning: isOnlineRunning,
    }"
    class="header noselect"
  >
    <div class="d-flex justify-content-start align-items-center overflow-hidden ml-2">
      <b-button v-if="reducedSystemMessage && isSystemMessagesAllowed" v-b-modal.modal-system-messages variant="light" size="sm" class="message-button" :title="reducedSystemMessage.subtitle">
        <small>
          <b-icon :icon="reducedSystemMessage.icon" :variant="reducedSystemMessage.variant"></b-icon>
          <span :class="`ml-2 text-${reducedSystemMessage.variant}`">{{ reducedSystemMessage.subtitle }}</span>
        </small>
      </b-button>

      <b-modal id="modal-system-messages" size="lg" centered scrollable title="Registro de Eventos" hide-footer @show="onModalSystemShow">
        <div class="accordion" role="tablist">
          <b-card v-for="(message, index) of staticSystemMessages" :key="index" no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="`accordion-${index}`" :variant="`outline-${message.variant}`" class="text-left collapsed">
                <span class="system-message-title">{{message.title}} - </span><span class="system-message-subtitle">{{ message.subtitle }}</span>
              </b-button>
            </b-card-header>
            <b-collapse :id="`accordion-${index}`" accordion>
              <b-card-body>
                <b-card-text>
                  <div>
                    <small><strong>Data e Hora do Ocorrido</strong>: </small>
                    <small><span v-text="message.date.format('DD/MM/YYYY, hh:mm:ss')"></span></small>
                  </div>
                  <div v-for="(key, mi) of Object.keys(message.bag)" :key="mi">
                    <small class="text-capitalize"><strong v-text="key"></strong>: </small>
                    <small><span v-text="message.bag[key]"></span></small>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-modal>

      <div class="txtFormat trigger-mode" v-if="user">
        <div v-if="!triggerActive && !maintenance">
          <label class="txtFormatOnlineReady"
          :title="$t('triggersOff')">{{$t('triggersOff')}}</label>
        </div>
      </div>
    </div>

    <div :class="[{ mr5: user }]" class="d-flex justify-content-center align-items-center">
      <img
        src="@/assets/logo-header.png"
        width="200"
        alt="Logo da Pentagro"
        v-if="!user"
      />
      <router-link v-if="(user)" to="/">
          <img src="@/assets/logo-systemP.png"
               width="250"
               alt="Pentagro GDI"
               v-if="user && user.onlineType == 'PGDI'" />
          <img src="@/assets/logo-systemG.png"
               width="250"
               alt="Pentagro GDI"
               v-if="user && user.onlineType == 'GDI'" />
      </router-link>
    </div>

    <div v-if="user" class="text-center d-flex justify-content-end align-items-center" @click="ChangeShowMsgBoxState">
      <span v-if="!isOnlineReady" :title="$t('waitingOnLineModeConfiguration')" class="txtFormatReadingConfiguration">
        <label class="clickProperties">{{$t('waitingOnLineModeConfiguration')}}</label>
      </span>
      <span
        v-if="isOnlineReady && !isOnlineRunning && changingStatus == 0"
        :title="$t('onlineModeReadyForActivation')"
        class="txtFormatOnlineReady clickProperties">
        <label class="clickProperties">{{$t('onlineModeReadyForActivation')}}</label>
      </span>
      <span v-if="changingStatus == 1"
        :title="$t('activatingOnline')"
        class="txtFormatOnlineReady">
        <label class="clickProperties">{{$t('activatingOnline')}}</label>
      </span>
      <span v-if="changingStatus == -1"
        :title="$t('deactivatingOnline')"
        class="txtFormatOnlineReady">
        <label class="clickProperties">{{$t('deactivatingOnline')}}</label>
      </span>
      <span v-if="(isOnlineRunning == true && changingStatus == 0) || rtoActive"
        :title="rtoActive ? 'RTO ativo' : $t('onlineActive')"
        class="txtFormatOnlineRunning">
        <label class="clickProperties">{{ rtoActive ? 'RTO ATIVO' : $t('onlineActive') }}</label>
        <span v-if="displayedModel"
        :title="$t('model')"> {{ $t('model') + displayedModel }}</span>
      </span>
      <span v-if="maintenance == true" class="txtMaintenance"
        :title="$t('maintenance')"
        >{{$t('maintenance')}}</span
      >
    </div>
  </header>
</template>

<script>
var taskStatus;
import { mapState } from "vuex";
import { urlMainAPI } from "@/global";
import axios from "axios";
import * as moment from "moment";

const EVENT_TYPES = {
  INFO: 'Info',
  ERROR: 'Error',
  WARNING: 'Warning',
  SUCCESS: 'Success'
}

export default {
  name: "Header",

  props: {
    title: String
  },

  computed: {
    ...mapState([
      "user",
      "isOnlineRunning",
      "activeModel",
      "isOnlineReady",
      "changingStatus",
      "autonomousMode",
      "triggerActive",
      "maintenance",
      "systemMessages",
      "rtoActive"
    ]),

    // Modelo a exibir no Header: apenas o activeModel do ONLINE em produção
    // (set pelo getOnlineModeStatus). O cenário carregado no PAP não é exibido
    // junto do selo "RTO ATIVO" porque o RTO sempre otimiza o PADRAO RTO,
    // independente do cenário que o operador está visualizando no PAP.
    displayedModel() {
      return this.activeModel || null;
    },
    /**
     * Reduz o conjunto de mensagens do sistema para uso no botão
     */
    reducedSystemMessage() {
      if(this.systemMessages) {
        let messages = this.getDistinctEventMessages() || [];
        
        if(messages.length) {
          return messages.reduce((accumulator, current) => {
            if(accumulator.total) {
              return {
                total: accumulator.total + 1,
                icon: accumulator.type === EVENT_TYPES.INFO ? current.icon : (current.type === EVENT_TYPES.INFO ? accumulator.icon : (current.type === EVENT_TYPES.ERROR ? current.icon : accumulator.icon)),
                variant: accumulator.type === EVENT_TYPES.INFO ? current.variant : (current.type === EVENT_TYPES.INFO ? accumulator.variant : (current.type === EVENT_TYPES.ERROR ? current.variant : accumulator.variant)),
                type: accumulator.type === EVENT_TYPES.INFO ? current.type : (current.type === EVENT_TYPES.INFO ? accumulator.type : (current.type === EVENT_TYPES.ERROR ? current.type : accumulator.type)),
                title: null,
                subtitle: 'Múltiplas Falhas Detectadas',
                origin: current.origin,
                categories: current.categories,
                date: current.date,
                bag: current.bag
              }
            } else {
              return {
                total: 1,
                icon: current.icon,
                variant: current.variant,
                type: current.type,
                title: current.title,
                subtitle: current.subtitle,
                origin: current.origin,
                categories: current.categories,
                date: current.date,
                bag: current.bag
              }
            }
          }, {});
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  },
  
  data: () => {
    return {
      isLogged: false,
      isSystemMessagesAllowed: false,
      staticSystemMessages: null
    };
  },

  methods: {
    StartGetOnline() {
      this.$store.dispatch("getOnlineModeStatus");
      this.$store.dispatch("fetchRtoActiveState");
      taskStatus = setTimeout(() => {
        this.StartGetOnline();
      }, 30000);
    },

    async getEnable() {
      if(!this.user) return;
        const url = `${urlMainAPI}/getsystemconfiguration`;
        await axios
          .get(url)
          .then((res) => {
            if(res.status == 200){
              this.$store.commit("setAutonomousMode", res.data.autonomousMode);
            }
          })
          .catch();
      },

    ChangeShowMsgBoxState(){
      let showMsgBox = this.$store.state.msgBoxState
      this.$store.commit("setMsgBoxState", !showMsgBox);
    },

    /**
     * Transforma as mensagens do sistema em um formato compatível com a tela
     */
     getTransformedSystemMessages() {
      if(this.systemMessages) {
        return this.systemMessages.map(message => ({
          icon: message.type === EVENT_TYPES.INFO ? 'exclamation-circle-fill' : 'exclamation-triangle-fill',
          variant: message.type === EVENT_TYPES.INFO ? 'info' : (message.type === EVENT_TYPES.ERROR ? 'danger' : 'warning'),
          type: message.type,
          title: message.title,
          subtitle: message.subtitle,
          origin: message.origin,
          categories: message.categories,
          date: moment(message.date),
          bag: message.bag
        }));
      }

      return null
    },

    /**
     * Filtra as mensagens por Rota e Categoria, e tempo máximo de 10min
     */
    filterEventMessages() {
        const messages = this.getTransformedSystemMessages();
        let filteredMessages = []
        
        if(messages && this.$route.name === 'dashboard') {
          filteredMessages = messages.filter(m => m.categories.indexOf('Dashboard') >= 0);
        } else if(messages && this.$route.name === 'areaspap')  {
          filteredMessages = messages.filter(m => m.categories.indexOf('PAP') >= 0);
        } else if (messages && ['monitoring', 'adherenceindicators', 'adherenceindicatorsgdi'].indexOf(this.$route.name) >= 0)  {
          filteredMessages = messages.filter(m => m.categories.indexOf('Monitoramento') >= 0);
        }

        const now = moment();
        const maxMinutes = 10;
        filteredMessages = filteredMessages.filter(m => now.diff(m.date, 'minutes') <= maxMinutes)

        return filteredMessages.length ? filteredMessages : null;
    },

    getDistinctEventMessages() {
      const messages = this.filterEventMessages()
      if(messages) {
        return messages.filter((value, index, self) => 
          index === self.findIndex((t) => (
            t.title === value.title && t.subtitle === value.subtitle && t.type === value.type
          ))
        );
      } else {
        return null;
      }
    },

    /**
     * Exibe mensagens estáticas para evitar atualização do modal quando o usuário estive usando
     */
    onModalSystemShow() {
      this.staticSystemMessages = this.getDistinctEventMessages();
    }
  },

  created() {
    clearTimeout(taskStatus);
    this.StartGetOnline();
  },

  beforeDestroy() {
    clearTimeout(taskStatus);
  },

  watch: {
    user(val) {
      // Após F5/login o user é restaurado de forma assíncrona — busca o estado
      // do RTO assim que isso acontece, sem esperar o próximo ciclo de polling.
      if (val) this.$store.dispatch("fetchRtoActiveState");
    },
    "$route": function () {

      // Inicia o processo de captura de enventos do sistema
      // if(['auth'].indexOf(to.name) < 0) {
      //   this.$store.dispatch("startMonitoringSystemMessages");
      // }

      this.isSystemMessagesAllowed = false
      
      // Só permite exibir o modal de mensagens do sistema em rotas específicas
      // if(['dashboard', 'monitoring', 'adherenceindicators', 'adherenceindicatorsgdi', 'areaspap'].indexOf(to.name) >= 0) {
      //   this.isSystemMessagesAllowed = true
      // } else {
      //   this.isSystemMessagesAllowed = false
      // }
    }
  }
};
</script>

<style scoped>

label{
  margin-bottom: 0;
}

.header {
  position: relative;
  height: 50px;
  width: 100%;
  background-color: rgb(0, 0, 0);

  grid-area: header;
  display: grid;
  grid-template-columns: 2fr 3fr 2fr;
  align-items: center;
  min-height: 0;
  min-width: 0;
}

.mr5 {
  margin-right: 45px;
}

.clickProperties:hover{
  cursor: pointer;
}

.trigger-mode {
  margin-left: 10px;
}

.txtFormatReadingConfiguration {
  color: white;
  font-size: 1em;
}
.txtFormatOnlineReady {
  color: #ff8d33;
  font-weight: 500;
  font-size: 1em;
}

.txtFormatOnlineRunning {
  color: #00a39f;
  font-size: 1.2em;
  letter-spacing: 1px;
  font-weight: 700;
  padding: 0 8px;
  display: grid;
}

.txtFormatOnlineRunning>label {
  margin: 0;
}

.txtFormatOnlineRunning>span {
  color: white;
  color: #fff9;
  font-size: 0.65em;
  font-weight: 600;
  line-height: 1.1;
  white-space: nowrap;
}

.txtMaintenance {
  font-weight: 700;
  color: #ff8d33;
  text-shadow: #0003 -2px 1px 1.5px;
  background-color: #fff;
  margin-left: 10px;
  padding: 2px 5px;
  position: fixed;
  height: 30px;
  top: 10px;
  left: 0px;
  border-radius: 3px;
  box-shadow: -2px 2px 3px #555; 
}

/* RESPONSIVIDADE DO HEADER */
@media only screen and (max-width: 1160px) {
  .onlineRunning, .onlineReadyNotRunning {
    flex-direction: column;
    justify-content: space-between;
    height: 80px;
  }
  .onlineRunning,
  .config-mode,
  .trigger-mode {
    position: static;
  }  
  /* .onlineReadyNotRunning {
    flex-direction: column;
    justify-content: space-between;
    height: 80px;
  } */

  .txtFormatReadingConfiguration{
    margin-left: 15px;
  }

  .onlineReadyNotRunning,
  .config-mode {
    position: static;
  }
  .txtMaintenance {
    top: 25px;
  }
}

@media only screen and (max-width: 960px) {
  .onlineNotReady {
    flex-direction: column;
    justify-content: space-between;
    height: 80px;
  }

  .txtFormatReadingConfiguration{
    margin-left: 0;
  }

  .onlineNotReady,
  .config-mode,
  .trigger-mode {
    position: static;
    font-size: 14px;
  }
}


@media only screen and (max-width: 770px) {
  .txtMaintenance {
    font-size: 0.95em;
    height: 26px;
    top: 27px;
  }
}

@media only screen and (max-width: 625px) {
  .txtMaintenance {
    font-size: 0.85em;
    height: 24px;
    top: 28px;
  }
}

@media only screen and (max-width: 555px) {
  .txtMaintenance {
    font-size: 0.80em;
    height: 22px;
    top: 49px;
  }
}

@media only screen and (max-width: 465px) {
  .txtFormatOnlineReady {
    font-size: 0.9em;
  }
  .txtFormatOnlineRunning {
    font-size: 1em;
  }
  .txtMaintenance {
    font-size: 0.75em;
    height: 20px;
    top: 50px;
  }
}

@media only screen and (max-width: 390px) {
  .txtFormatOnlineReady {
    font-size: 0.8em;
  }
  .txtFormatOnlineRunning {
    font-size: 0.9em;
  }
  .txtMaintenance {
    font-size: 0.7em;
    height: 18px;
    top: 51px;
  }
}

@media only screen and (max-width: 345px) {
  .txtFormatOnlineReady{
    font-size: 0.7em;
  }
  .txtFormatOnlineRunning {
    font-size: 0.8em;
  }
  .txtMaintenance {
    font-size: 0.65em;
    height: 16px;
    top: 52px;
  }
}

.message-button {
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
 }

 .btn-outline-warning {
  color: #ffc281;
  border-color: #ffc281;
 }


 .btn-outline-info .system-message-title,
 .btn-outline-warning .system-message-title,
 .btn-outline-danger .system-message-title {
  font-weight: 500;
 }
 
 .btn-outline-info .system-message-subtitle,
 .btn-outline-warning .system-message-subtitle,
 .btn-outline-danger .system-message-subtitle {
  color: initial;
 }
 
</style>
